module.exports = __webpack_public_path__ + "img/primaPay.1b758ce8.png";